import { EnumRichiestaDTOStatoPreventivi } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaDTOStatoPreventivi.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { useTranslation } from 'react-i18next';

export function useQuoteActionRequiredMessages(
  submission: RichiestaDTO | null | undefined,
) {
  const { t } = useTranslation();

  return submission?.statoPreventivi ===
    EnumRichiestaDTOStatoPreventivi.DA_ACCETTARE
    ? t(
        'submission-state-tag.richiesta-accettazione-preventivo',
        "È richiesta l'accettazione del Preventivo",
      )
    : submission?.statoPreventivi === EnumRichiestaDTOStatoPreventivi.DA_PAGARE
      ? t(
          'submission-state-tag.richiesta-pagamento-preventivo',
          'È richiesto il pagamento del Preventivo',
        )
      : t(
          'submission-state-tag.sono-presenti-preventivi',
          'Sono presenti preventivi',
        );
}

interface IQuoteActionRequiredMessagesProps {
  submission: RichiestaDTO | null | undefined;
}

export function QuoteActionRequiredMessages(
  props: IQuoteActionRequiredMessagesProps,
) {
  const { submission } = props;
  const text = useQuoteActionRequiredMessages(submission);
  return text;
}
